export default function Avatar({ name, picture: { url }, title, smallImg }) {
    return (
        <div className="flex items-center flex-row">
            <img
                style={{ width: smallImg ? "2.7rem" : "4rem", height: smallImg ? "2.7rem" : "4rem" }}
                src={url}
                className="rounded-full mr-4"
                alt={name}
            />
            <div>
                <div className="text-lg font-medium">{name}</div>
                <div className="text-lg text-gray-500 font-normal">{title}</div>
            </div>
        </div>
    )
}